import { useEffect, useMemo } from 'react';
import { useFormikContext } from 'formik';
import { PreTransformSchemaFormValues } from '@/zod/schemas/dataSource/PreTransform';
import { useGetDatasourcePreset } from '@/hooks/content/useGetDatasourcePreset';
import { useConfigDataSource } from '@/contexts/ConfigDataSourceContext';
import { DataSourceFilters } from '@/components/dataSources/filters/DataSourceFilters';

export default function PreTransformFilters() {
  const formik = useFormikContext<PreTransformSchemaFormValues>();
  const { dataSource } = useConfigDataSource();

  const { values } = formik;

  const { data: presets } = useGetDatasourcePreset({
    name: dataSource.spec.usePreset || undefined,
  });

  const preset = useMemo(
    () =>
      presets?.silver?.preTransform?.find(
        ({ name }) => name === values.usePreset,
      ),
    [presets, values.usePreset],
  );

  const { setFieldValue } = formik;

  useEffect(() => {
    if (!preset) {
      return;
    }
    setFieldValue('filter', preset.filter || '');
  }, [preset, setFieldValue]);

  useEffect(() => {
    if (!preset) {
      return;
    }
    setFieldValue('postFilter', preset.postFilter || '');
  }, [preset, setFieldValue]);

  return <DataSourceFilters filters={values} />;
}
